import {updateusers} from "@/api/user";

const getDefaultState = () => {
    return {
        userInfo: null,
        clientId: null,
        carlist: null,
        DRIVER_ENUM: {
            EXAM_SUBJECT_1: [],
            EXAM_SUBJECT_4: [],
            EXAM_FULL_SCORE_REVIEW: [],
            EXAM_LICENSE_RESTORE: [],
        },
        answeringRules: {
            rule_score: {},
            rule_switch: {}
        }, //当前答题规则
    }
}

const state = getDefaultState()

// 同步更新
const mutations = {
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
        localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    SET_CLIENT_ID(state, clientId) {
        state.clientId = clientId
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState()) // 重置 state
        localStorage.removeItem('userInfo')     // 清除缓存
    },
    SET_ANSWERING_RULES(state, answeringRules) {
        state.answeringRules = answeringRules
    },
    SET_CARLIST(state, carlist) {
        state.carlist = carlist
        const {driver} = carlist
        const obj = {
            EXAM_SUBJECT_1: [],
            EXAM_SUBJECT_4: [],
            EXAM_FULL_SCORE_REVIEW: [],
            EXAM_LICENSE_RESTORE: []
        }
        driver.forEach((item) => {
            item.car_subject.forEach((sub) => {
                if (obj[sub.page_code.split(':')[1]]) {
                    obj[sub.page_code.split(':')[1]].push({
                        ...sub,
                        car_type_name: item.name,
                        car_type_description: item.description,
                        car_type_prefix_page_code: item.prefix_page_code,
                    })
                }
            })
        })
        state.DRIVER_ENUM = obj

    }
};
// 异步更新
const actions = {
    setUserInfo({commit}, userInfo) {
        let localUserInfo = localStorage.getItem('userInfo') || '{}';
        commit('SET_USER_INFO', Object.assign(JSON.parse(localUserInfo), userInfo));
    },
    setClientId({commit}, clientId) {
        commit('SET_CLIENT_ID', clientId)
    },
    setCarlist({commit}, carlist) {
        commit('SET_CARLIST', carlist)
    },
    setVer({commit}, banben) {
        let localUserInfo = localStorage.getItem('userInfo') || '{}';
        commit('SET_USER_INFO', {...JSON.parse(localUserInfo), ui_version: banben})
        updateusers({ui_version: banben})
    },
    logout({commit}) {
        commit('RESET_STATE') // 调用重置
    }

};
//  获取
const getters = {
    userInfo: state => state.userInfo,
    getClientId: state => state.clientId,
    getDRIVER_ENUM: state => state.DRIVER_ENUM,
    getCarlist: state => state.carlist,
    getRuleScore: state => state.answeringRules.rule_score,
    getHasNewRules: state => state.answeringRules.rule_switch,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
